import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import codeItem from './codeItem';
import { qrConfigList, CODENODE } from './../request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { templateGroupResources } from '@/views/template/templateGroupManage/request';
export default {
  components: {
    codeItem
  },
  props: {
    customerInsuranceId: {
      type: Number,
      default: 0
    },
    insuranceId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeKey: ['-1'],
      list: [],
      templateGroupList: []
    };
  },
  created() {
    this.$nextTick(() => {
      this.getTemplateGroupFun();
      this.getInfoFun();
    });
  },
  methods: {
    async getInfoFun() {
      this.list = await qrConfigList({
        customerInsuranceId: this.customerInsuranceId
      });
    },
    async getTemplateGroupFun() {
      this.templateGroupList = await templateGroupResources({});
    },
    addCodeFun() {
      let num = this.list.find(item => item.isEdit);
      if (num) {
        return this.$message.error(this.$t('请先保存完数据再新增') + '!');
      }
      const obj = recursionCopy(CODENODE);
      obj.customerInsuranceId = Number(this.customerInsuranceId);
      this.list.push(obj);
      this.activeKey.push(String(-1));
    },
    cancelFun(index) {
      if (this.list[index].id == -1) {
        this.list.splice(index, 1);
      } else {
        this.list[index].isEdit = false;
      }
    },
    editFun(index) {
      console.log(444);
      let num = this.list.find(item => item.isEdit);
      if (num) {
        return this.$message.error(this.$t('请先保存完数据再编辑其他二维码信息') + '!');
      }
      this.list[index - 1].isEdit = true;
    }
  }
};